<template>
<div class="chapter">
<div class="inner_page">
<p class="hang1"><b>me • rid • i • an</b>, <i>n.</i> [L. <i>meridianus,</i> pertaining to midday, or to the south, from <i>meridies,</i> midday, the south; <i>medius,</i> middle, and <i>dies,</i> day.]</p>
<blockquote style="margin-top:0px;">
<ol style="margin-top:0px;">
<li>the highest apparent point reached by a heavenly body in its course.</li>
<li>(a)the highest point of power, prosperity, splendor, etc.; zenith; apex; culmination; (b)the middle period of one’s life, regarded as the highest point of health, vigor, etc.; prime.</li>
<li>noon. [<i>Obs.</i>]</li>
<li>in astronomy, an imaginary great circle of the celestial sphere passing through the poles of the heavens and the zenith and nadir of any given point, and cutting the equator at right angles.</li>
<li>in geography, (a) a great circle of the earth passing through the geographical poles and any given point on the earth’s surface; (b) the half of such a circle between the poles; (c) any of the lines of longitude running north and south on a globe or map, representing such a circle or half-circle.</li>
<li>(a) a place or situation with its own distinctive character; (b) distinctive character.</li>
<li>a graduated ring of brass, in which a globe is suspended and revolves.</li>
</ol>
<blockquote style="margin-top:0px;">
<blockquote style="margin-top:0px;">
<p class="noind" style="margin-top:0px;"><span><i>first meridian:</i> see <i>prime meridian</i> under <i>prime.</i></span></p>
<p class="noind"><span><i>magnetic meridian:</i> a carefully located meridian from which secondary or guide meridians may be constructed.</span></p>
</blockquote>
</blockquote>
</blockquote>
<p class="hang1"><b>me • rid i • an, <i>a.</i></b></p>
<blockquote style="margin-top:0px;">
<ol style="margin-top:0px;">
<li>of or at noon or, especially, of the position or power of the sun at noon.</li>
<li>of or passing through the highest point in the daily course of any heavenly body.</li>
<li>of or along a meridian.</li>
<li>of or at the highest point of prosperity, splendor, power, etc.</li>
<li>southern. [Rare.]</li>
</ol>
</blockquote>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 6-part.vue?9432ff64